import React, { Component } from 'react';
import { Table } from 'antd';
import { app } from "../app";
import Head from "../components/Head";
import '../css/updateLog.css';
import api from "../api";
import utils from "../utils";

class UpdateLogs extends Component {
    constructor (props) {
        super(props);
        this.state = {
            logList: [],
        };
    }

    async componentDidMount () {
        this._isMounted = true;
        await this.dataSource();
    }

    componentWillUnmount () {
        this._isMounted = false;
    }

    /**
     * 设置值
     * @param data
     */
    setData = async (data) => {
        await app.setStateSync(this, data);
    }

    /**
     * 数据源
     */
    dataSource = async () => {
        await this.setState({ data_loading: true });
        let { flag, data, msg } = await app.post(api.VersionsInfoList);
        if (flag !== 1) {
            app.alert(msg, "error");
            data = [];
        }
        // for (let i = 0; i < 5; i++) {
        //     data = data.concat(data);
        // }
        await this.setData({ data_loading: false, logList: utils.addArrayKey(data) });
    }

    render () {
        let { logList, data_loading } = this.state,
            columns = [
                {
                    title: '版本号',
                    dataIndex: 'versions',
                    key: 'versions',
                    width: '20%'
                },
                {
                    title: '更新日期',
                    dataIndex: 'update_time',
                    key: 'update_time',
                    width: '20%'
                },
                {
                    title: '更新内容',
                    dataIndex: 'update_content',
                    key: 'update_content',
                    width: '60%',
                    render (content) {
                        return (
                            <div style={{textAlign: 'left'}}>
                                <p>{content}</p>
                                {/*<TextArea disabled={true} className="update-content" value={content}/>*/}
                            </div>);
                    }
                }
            ];
        return (
            <div className="update-logs">
                <Head history={this.props.history} background="rgb(63, 137, 193)" height={78}/>
                <div className="log-content">
                    <div className="log-title">更新内容</div>
                    <Table
                        size="small"
                        bordered
                        columns={columns}
                        pagination={false}
                        dataSource={logList}
                        loading={data_loading}
                        locale={app.tbLocale(data_loading)}
                        className="log-table"
                        scroll={{ y: 'calc(100% - 58px)' }}
                    />
                </div>
            </div>
        );
    }
}

export default UpdateLogs;



// WEBPACK FOOTER //
// ./src/routes/UpdateLogs.jsx